"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimeout = useTimeout;
const react_1 = require("react");
function useTimeout(callback, delay) {
    const savedCallback = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        savedCallback.current = callback;
    }, [callback]);
    (0, react_1.useEffect)(() => {
        function tick() {
            var _a;
            (_a = savedCallback.current) === null || _a === void 0 ? void 0 : _a.call(savedCallback);
        }
        const id = setTimeout(tick, delay);
        return () => clearTimeout(id);
    }, [delay]);
}
